import { Agent, Channel } from '@nemuru-eng/js-api-client';
import { useCallback, useEffect } from 'react';

import { ApplicationStepContainer } from '@/components/modules/Application/components/_shared/components/ApplicationStepContainer';
import { ApplicationStepNav } from '@/components/modules/Application/components/_shared/components/ApplicationStepNav';
import { Section } from '@/components/modules/Application/components/_shared/components/Section/Section';
import { SectionTitle } from '@/components/modules/Application/components/_shared/components/Section/SectionTitle';
import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';
import { useGetApplicationSteps } from '@/components/modules/Application/hooks/useGetApplicationSteps';
import { useSetIsDirtyListener } from '@/components/modules/Application/hooks/useSetDirtyListener';
import { AgentSelectionComponent } from '@/components/shared/components/AgentSelectionComponent/AgentSelectionComponent';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';
import { useUser } from '@/hooks/useUser';
import { MerchantInStructure } from '@/types/MerchantInStructure';

export const AgentSelection = () => {
  const {
    state: { selectedAgentHasError, selectedAgent, selectedChannel, selectedMerchant },
    actions: { updateApplicationContext },
  } = useApplicationContext();
  const { isUserChannel, currentChannel } = useUser();
  const { initApplication, onNext, resetNavigation } = useApplicationNavigation();
  const { getSteps } = useGetApplicationSteps();

  useSetIsDirtyListener(selectedAgent);
  useSetIsDirtyListener(selectedChannel);

  useEffect(() => {
    initApplication();
    resetNavigation(getSteps());
  }, []);

  const onChange = (
    selectedAgent: Agent | undefined,
    selectedChannel: Channel | undefined,
    selectedMerchant: MerchantInStructure | undefined,
  ) => {
    updateApplicationContext({
      selectedAgent,
      selectedChannel,
      selectedMerchant,
      selectedAgentHasError: undefined,
    });
  };

  const resetItem = useCallback(() => !selectedAgent, [selectedAgent]);

  return (
    <ApplicationStepContainer>
      <Section>
        <SectionTitle title={'SALES_PROFILE'} subtitle={'SALES_PROFILE_SELECT'} />
        <AgentSelectionComponent
          initialValues={{
            selectedChannel: selectedChannel || (!!isUserChannel && currentChannel) || undefined,
            selectedAgent,
            selectedMerchant,
          }}
          onChange={onChange}
          error={selectedAgentHasError === true ? 'SELECTED_AGENT_ERROR_ALERT' : undefined}
          resetItem={resetItem}
          fullWidth
        />
      </Section>
      <ApplicationStepNav
        disableOnNext={selectedAgentHasError !== false}
        onNext={onNext}
        loading={!!selectedAgent && selectedAgentHasError === undefined}
      />
    </ApplicationStepContainer>
  );
};
